
import { StrictMode } from 'react';
import Board from './components/Board';
import 'bootstrap/dist/css/bootstrap.min.css';
import './css/App.css';


function App() {
  console.log('gotch ya!');
  console.log('gotch ya!');
  return (
    <StrictMode>
      <Board />
    </StrictMode>
  );
}


export default App;
